module.exports = __webpack_public_path__ + "static/laptop.4553c633.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/laptop.jpg
// module id = ./src/pages/laptop.jpg
// module chunks = 4898604195644612000